export const PERSONAL_CONTENT_CONFIG_LOCAL_STORAGE_KEY = 'personal-content-config';
